module.exports = __webpack_public_path__ + "static/img/25.a35f40d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/25.png
// module id = wg+Q
// module chunks = 1